import { render, staticRenderFns } from "./BackendReports.vue?vue&type=template&id=0c19a750&scoped=true&"
import script from "./BackendReports.vue?vue&type=script&lang=js&"
export * from "./BackendReports.vue?vue&type=script&lang=js&"
import style0 from "./BackendReports.vue?vue&type=style&index=0&id=0c19a750&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c19a750",
  null
  
)

export default component.exports